import { StoreContext } from "@roc/feature-app-core";
import { ClosingTrackerStore } from "../stores/closingTrackerStore";
import { useContext } from "react";

export const useClosingTrackerStore = () =>
  useContext<{
    closingTrackerStore: ClosingTrackerStore;
  }>(StoreContext);
